import StartEndDurationUtils from "../start-end-duration/start-end-duration-utils";
import WorkScheduleProto, {WorkScheduleDayStatus} from "./work-schedule-proto";
import CompanyWorkSchedule from "./company-work-schedule";
import CompanyUser from "../../../model2/company-user-new/company-user";
import DatetimeUtils from "../../utils/datetime-utils"

export default class UserWorkSchedule extends WorkScheduleProto {

    public userId              : ID
    public companyWorkSchedule : CompanyWorkSchedule
    public userVacations       : Set<any>   = new Set()
    public userSickLeaves      : Set<any>   = new Set()
    public momentCreated       : Moment | null = null

    constructor(userId:ID, companyWorkSchedule:CompanyWorkSchedule, userPersonalEvents:any[]) {
        super();

        this.userId = userId;
        this.companyWorkSchedule = companyWorkSchedule;

        this.updateEvents(userPersonalEvents);

        this.updateWorkdayDurations()
    }

    updateEvents(userPersonalEvents:any[]) {
        // split personalEvents into vacations and sick leaves
        const vacations = _.filter(userPersonalEvents, e=>[
            gd.const.event.type.PERSONAL_PAID_VACATION,
            gd.const.event.type.PERSONAL_NON_PAID_VACATION
        ].includes(e.type));

        const sickLeaves = _.filter(userPersonalEvents, e=>[
            gd.const.event.type.PERSONAL_SICK_LEAVE
        ].includes(e.type));


        this.userVacations = new Set(StartEndDurationUtils.getHolidaysFromEvents(vacations));
        this.userSickLeaves = new Set(StartEndDurationUtils.getHolidaysFromEvents(sickLeaves));
    }

    updateWorkdayDurations(){
        const companyUser: CompanyUser = gd.session.companyUsers.findByCompanyAndUser(gd.companyId, this.userId)!;

        //get workday durations
        this.workDayDurations = companyUser && _.sum(companyUser.workdayDurations) > 0 ? companyUser.workdayDurations : gd.company.settings.workSchedule.workdayDurations //[480, 0, 480, ...]

        this.momentCreated = companyUser?.momentCreated ?? null
    }

    getHolidays() {
        // @ts-ignore
        return [].concat([...this.companyWorkSchedule.companyHolidays]).concat([...this.userVacations]).concat([...this.userSickLeaves]);
    }

    isHoliday(dateString:string) {
        return this.companyWorkSchedule.isHoliday(dateString);
    }

    isVacation(dateString:string) {
        // v buduchem nado konechno sam event eche vozvrachat' budet....
        return this.userVacations.has(dateString);
    }

    isSickLeave(dateString:string) {
        // v buduchem nado konechno sam event eche vozvrachat' budet....
        return this.userSickLeaves.has(dateString);
    }

    isBeforeCreation(dateString:string) {
        if (!this.momentCreated) {
            return false
        }
        return moment(dateString).isBefore(this.momentCreated, 'day')
    }

    isWeekend(dateString:string) {
        // isoWeekday is in range 1-7, workDayDurations is like [480,480,480,480,480,0,0] and we check for 0 value to be weekend
        return this.workDayDurations[moment(dateString).isoWeekday() - 1] === 0;
    }

    // carefull with === for true (!!!!!)
    isWorkingDay(dateString:string) : true | WorkScheduleDayStatus {
        let res = true;

        if (this.isBeforeCreation(dateString))  return WorkScheduleDayStatus.USER_BEFORE_CREATION   // if before user creation - ne rabotaem
        else if (this.isHoliday(dateString))    return WorkScheduleDayStatus.COMPANY_HOLIDAY        // if company holiday - ne rabotaem
        else if (this.isVacation(dateString))   return WorkScheduleDayStatus.USER_VACATION          // if user vacation - ne rabotaem
        else if (this.isSickLeave(dateString))  return WorkScheduleDayStatus.USER_SICK_LEAVE        // if user sick - ne rabotaem
        else if (this.isWeekend(dateString))    return WorkScheduleDayStatus.USER_WEEKEND           // if user weekend - ne rabotaem;

        return res;
    }

    getWorkdayDuration(dateMoment: Moment): number {
        return this.isWorkingDay(DatetimeUtils.momentToDate(dateMoment)!) ? this.workDayDurations[dateMoment.isoWeekday() - 1] : 0
    }
}
